// extracted by mini-css-extract-plugin
export var checkbox = "SectionContactUs-module--checkbox--jI6LF";
export var flex = "SectionContactUs-module--flex--aNnnf";
export var form = "SectionContactUs-module--form--T9SiJ";
export var inputs = "SectionContactUs-module--inputs--id67V";
export var section = "SectionContactUs-module--section--tx+4e";